import Image from '@tiptap/extension-image'
import { getVaultFileObjectUrl } from '@/lib/api'

// srcs that are already loadable by the browser as-is — leave them alone.
const RESOLVABLE = /^(https?:|data:|blob:)/i

/**
 * TipTap image node that renders vault-relative image srcs.
 *
 * Cards embed images as markdown links to a vault path, e.g.
 * `![alt](<Walker/.../Receipt.png>)`. The browser can't load that path off the
 * web root, so the stock Image extension shows a broken icon. This NodeView
 * keeps the node's `src` attribute = the vault path (so markdown round-trips
 * unchanged on save) but DISPLAYS the image via the authenticated vault-file
 * blob URL. External/data/blob srcs are passed through untouched.
 */
export const VaultImage = Image.extend({
  addNodeView() {
    return ({ node }) => {
      const img = document.createElement('img')
      const src: string = node.attrs.src || ''
      if (node.attrs.alt) img.alt = node.attrs.alt
      if (node.attrs.title) img.title = node.attrs.title

      let objectUrl: string | null = null
      if (!src || RESOLVABLE.test(src)) {
        img.src = src
      } else {
        // Vault path (relative or absolute) — fetch the authed blob.
        getVaultFileObjectUrl(src)
          .then((url) => {
            objectUrl = url
            img.src = url
          })
          .catch(() => {
            img.alt = `${node.attrs.alt || 'image'} (unavailable)`
          })
      }

      return {
        dom: img,
        destroy() {
          if (objectUrl) URL.revokeObjectURL(objectUrl)
        },
      }
    }
  },
})
